import {
	queryClient,
	SociosSocketEvent,
	type SocketsListener,
	useSocketEventListener,
	withRefreshStrategy
} from '@capsicum/common';
import { useCallback, useMemo } from 'react';

import { usePartners } from '../../partners/hooks';

/**
 * This component registers a single socket listener for balance updates
 * to prevent multiple listeners when multiple balance components are mounted.
 *
 * TODO: Currently only handles SSU/Reward Points balance updates.
 * In the future, extend this to handle different currencyIds
 */
export const UserBalanceUpdateListeners = () => {
	const { getPartnerBy } = usePartners();

	const ssuCurrencyId = useMemo(() => getPartnerBy(p => p.shortName === 'SSU')?.currencyId, [getPartnerBy]);

	const walletBalanceUpdateListener = useCallback(
		(data: {
			payload: {
				currencyBalances: Array<{ currencyId: string }>;
			};
		}) => {
			const currencyIds = data?.payload?.currencyBalances?.map(balance => balance.currencyId);

			if (ssuCurrencyId && currencyIds?.includes(ssuCurrencyId)) {
				queryClient.invalidateQueries({ queryKey: ['rewardPointBalance'] });
			}
		},
		[ssuCurrencyId]
	);

	const listeners = useMemo(() => {
		return new Map<SociosSocketEvent, SocketsListener>([
			[SociosSocketEvent.WALLET_BALANCE_UPDATED, withRefreshStrategy({ listener: walletBalanceUpdateListener })]
		]);
	}, [walletBalanceUpdateListener]);

	useSocketEventListener(listeners, !!ssuCurrencyId);

	return null;
};
